import imageCompression from 'browser-image-compression';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { readUserApi, updateUserApi } from './Api';
import PassModal from './PasswordModal';

const UsrProfileSection = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    full_name: '',
    email: '',
    birthdate: '',
    gender: '',
    weight: '',
    height: '',
    profile_image: null,
    is_hide_identity: '',

  });

  const [loading, setLoading] = useState(true);
  const [editingField, setEditingField] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);

  async function readUser() {
    const updatedUser = await readUserApi();

    setForm({
      full_name: updatedUser.full_name || '',
      email: updatedUser.email || '',
      birthdate: updatedUser.birthdate || '',
      gender: updatedUser.gender || '',
      weight: updatedUser.weight || '',
      height: updatedUser.height || '',
      profile_image: updatedUser.profile_image || null,
      is_hide_identity: updatedUser.is_hide_identity ?? true, // ✅ map API value

    });
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        await readUser();
        setLoading(false);
      } catch (err) {
        console.error('Failed to load user data:', err);
        if (err.message.includes('Unauthorized')) {
          navigate('/login');
        } else {
          alert('Error: ' + err.message);
        }
      }
    };

    fetchUserData();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };




  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setImageUploading(true);

      const options = { maxSizeMB: 0.01, maxWidthOrHeight: 1024, fileType: 'image/jpeg', initialQuality: 0.3 };
      const compressedFile = await imageCompression(file, options);
      const finalFile = new File([compressedFile], "profile.jpg", { type: "image/jpeg" });

      setForm((prev) => ({ ...prev, profile_image: finalFile }));

      const cleanedForm = {};
      Object.entries(form).forEach(([key, value]) => { if (value !== '') cleanedForm[key] = value; });

      const formData = new FormData();
      formData.append('data', JSON.stringify(cleanedForm));
      formData.append('profile_image', finalFile);

      await updateUserApi(formData);
      await readUser();
    } catch (err) {
      alert('Image upload failed: ' + err.message);
    } finally {
      setImageUploading(false);
    }
  };

  const handleSave = async (fieldName) => {
    const value = form[fieldName];
    const cleanedData = {};


    if (fieldName === "birthdate" && calculateAge(form.birthdate) < 18) {
      alert("You must be at least 18 years old.");
      return;
    }
    if (fieldName === "height") {
      const h = parseFloat(form.height);
      if (isNaN(h) || h < 1 || h > 12) {
        alert("Height must be between 1 and 12 ft.");
        return;
      }
      cleanedData.height = h;
    }


    if (['weight', 'height'].includes(fieldName)) {
      if (value === '') {
        cleanedData[fieldName] = null;
      } else if (isNaN(value)) {
        alert(`${fieldName} must be a valid number.`);
        return;
      } else {
        cleanedData[fieldName] = parseFloat(value);
      }
    } else {
      cleanedData[fieldName] = value;
    }

    const formData = new FormData();
    formData.append('data', JSON.stringify(cleanedData));

    try {
      await updateUserApi(formData);
      await readUser();
      setEditingField(null);
    } catch (err) {
      alert('Update failed: ' + err.message);
    }
  };

  const calculateAge = (birthdate) => {
    if (!birthdate) return '';
    const birth = new Date(birthdate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age;
  };


  return (
    <div className="container py-4">
      <div className="mx-auto" style={{

       // backgroundColor: '#ff9b45',
        border: 'none',
        boxShadow: 'none'
      }}>

        <div className="card-body" style={{
          height: '100%'      // very small card body height

        }}>
          <div className="text-center mb-2">
            <h2 style={{
                padding: '10px',
                fontSize: '50px',
                fontWeight: '700',
                fontStyle: 'bolder',
                color: '#740A03',
                fontFamily: 'Arial, sans-serif'
              }}>PROFILE</h2>

            <div className="d-flex flex-column align-items-center">
              <div className="position-relative mb-2">
                <div
                  style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                  onClick={() => document.getElementById('profileImageInput').click()}
                >
                  {form.profile_image ? (
                    <img
                      src={`${form.profile_image}?t=${Date.now()}`}
                      alt="Profile"
                      className="rounded-circle border"
                      style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: imageUploading ? 0.5 : 1 }}
                    />
                  ) : (
                    <div className="bg-secondary rounded-circle" style={{ width: '100%', height: '100%' }} />
                  )}

                  {imageUploading && (
                    <div
                      className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                      }}
                    >
                      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
                        <span className="visually-hidden">Uploading...</span>
                      </div>
                    </div>
                  )}
                </div>

                <input
                  type="file"
                  accept="image/*"
                  id="profileImageInput"
                  onChange={handleImageChange}
                  className="d-none"
                />
              </div>

              <h4 className="mt-2">
                {editingField === 'full_name' ? (
                  <>
                    <input
                      type="text"
                      name="full_name"
                      className="form-control"
                      value={form.full_name}
                      onChange={handleChange}
                    />
                    <div className="mt-2">
                      <button className="btn btn-outline-success btn-sm me-1" onClick={() => handleSave('full_name')}>
                        💾
                      </button>
                      <button className="btn btn-outline-secondary btn-sm" onClick={() => setEditingField(null)}>
                        ❌
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    {form.full_name}
                    <button className="btn btn-sm text-muted ms-2 p-0" onClick={() => setEditingField('full_name')}>
                      ✎
                    </button>
                  </>
                )}
              </h4>
            </div>



          </div>

          <div className="text-start">

            <div className="mb-3">
              <p className="mb-1 fw-semibold"
              style={{
                fontSize: '20px',
                fontWeight: '700',
                fontStyle: 'bolder',
                color: '#740A03',
                fontFamily: 'Arial, sans-serif'
              }}>Email</p>
              <div className="input-group">
                {editingField === 'email' ? (
                  <>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={form.email}
                      onChange={handleChange}
                    />
                    <button className="btn btn-outline-success" onClick={() => handleSave('email')}>💾</button>
                    <button className="btn btn-outline-secondary" onClick={() => setEditingField(null)}>❌</button>
                  </>
                ) : (
                  <>
                    <input className="form-control" value={form.email} readOnly />
                    <span className="input-group-text" style={{ cursor: 'pointer' }} onClick={() => setEditingField('email')}>✎</span>
                  </>
                )}
              </div>
            </div>

            <p className="fw-semibold mb-1"
            style={{
                fontSize: '20px',
                fontWeight: '700',
                fontStyle: 'bolder',
                color: '#740A03',
                fontFamily: 'Arial, sans-serif'
              }}>Age & Birthday</p>

            <div className="input-group mb-3">
              <span className="input-group-text bg-light fw-bold">
                {calculateAge(form.birthdate) || 'N/A'}
              </span>

              {editingField === 'birthdate' ? (
                <>
                  <DatePicker
                    selected={form.birthdate ? new Date(form.birthdate) : null}
                    onChange={(date) =>
                      setForm((prev) => ({
                        ...prev,
                        birthdate: date.toISOString().split('T')[0], // store as YYYY-MM-DD
                      }))
                    }
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select your birthday"
                    minDate={new Date(1900, 0, 1)} // optional lower limit
                    maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))} // 18+ only
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />

                  <button
                    className="btn btn-outline-success"
                    onClick={() => handleSave('birthdate')}
                  >
                    💾
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setEditingField(null)}
                  >
                    ❌
                  </button>
                </>
              ) : (
                <>
                  <input className="form-control" value={form.birthdate} readOnly />
                  <span
                    className="input-group-text"
                    onClick={() => setEditingField('birthdate')}
                    style={{ cursor: 'pointer' }}
                  >
                    ✎
                  </span>
                </>
              )}
            </div>





            {['gender', 'height', 'weight'].map((field) => (
              <div key={field} className="mb-2">
                <p className="mb-1 text-capitalize"
                style={{
                fontSize: '20px',
                fontWeight: '600',
                fontStyle: 'bold',
                color: '#740A03',
                fontFamily: 'Arial, sans-serif'
              }}>{field}</p>
                <div className="input-group">
                  {editingField === field ? (
                    <>
                      {field === 'gender' ? (
                        <select className="form-select" name={field} value={form[field]} onChange={handleChange}>
                          <option value="">-- Select Gender --</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      ) : (
                        <>
                          <input className="form-control" type="text" name={field} value={form[field]} onChange={handleChange} />
                          <span className="input-group-text">{field === 'height' ? 'ft' : 'kg'}</span>
                        </>
                      )}
                      <button className="btn btn-outline-success" onClick={() => handleSave(field)}>💾</button>
                      <button className="btn btn-outline-secondary" onClick={() => setEditingField(null)}>❌</button>
                    </>
                  ) : (
                    <>
                      <input className="form-control" value={form[field]} readOnly />
                      <span className="input-group-text" style={{ cursor: 'pointer' }} onClick={() => setEditingField(field)}>
                        {field === 'height' ? 'ft ✎' : field === 'weight' ? 'kg ✎' : '✎'}
                      </span>
                    </>
                  )}
                </div>





              </div>



            ))}


            <div className="mb-3" style={{ display: "none" }}>
              <label className="form-label fw-semibold">Hide my identity</label>
              <div className="input-group">
                {editingField === "is_hide_identity" ? (
                  <>
                    <select
                      className="form-select"
                      name="is_hide_identity"
                      value={form.is_hide_identity ? "yes" : "no"}
                      onChange={(e) => {
                        const newValue = e.target.value === "yes";

                        if (!newValue) {
                          alert(
                            "By opting out (No), you agree that your age, height, weight, location, and gender will be accessible on the platform where all players can search."
                          );
                        }

                        setForm((prev) => ({
                          ...prev,
                          is_hide_identity: newValue,
                        }));
                      }}
                    >
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    <button
                      className="btn btn-outline-success"
                      onClick={() => handleSave("is_hide_identity")}
                    >
                      💾
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setEditingField(null)}
                    >
                      ❌
                    </button>
                  </>
                ) : (
                  <>
                    <input
                      className="form-control"
                      value={form.is_hide_identity ? "Yes" : "No"}
                      readOnly
                    />
                    <span
                      className="input-group-text"
                      onClick={() => setEditingField("is_hide_identity")}
                      style={{ cursor: "pointer" }}
                    >
                      ✎
                    </span>
                  </>
                )}
              </div>
            </div>


            <div className="d-grid mt-3">
              <PassModal />
            </div>
          </div>




        </div>
      </div>
    </div>
  );
};

export default UsrProfileSection;
